import f from "./ghl-ui.es1610.js";
import m from "./ghl-ui.es1514.js";
var z = 60 * 1e3, v = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, n, r) {
    var t = c(r.timeZone, r._originalDate || e);
    if (t === 0)
      return "Z";
    switch (a) {
      case "X":
        return l(t);
      case "XXXX":
      case "XX":
        return i(t);
      case "XXXXX":
      case "XXX":
      default:
        return i(t, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, n, r) {
    var t = c(r.timeZone, r._originalDate || e);
    switch (a) {
      case "x":
        return l(t);
      case "xxxx":
      case "xx":
        return i(t);
      case "xxxxx":
      case "xxx":
      default:
        return i(t, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, n, r) {
    var t = c(r.timeZone, r._originalDate || e);
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + O(t, ":");
      case "OOOO":
      default:
        return "GMT" + i(t, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, n, r) {
    var t = r._originalDate || e;
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return f("short", t, r);
      case "zzzz":
      default:
        return f("long", t, r);
    }
  }
};
function c(e, a) {
  var n = e ? m(e, a, !0) / z : a.getTimezoneOffset();
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function s(e, a) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < a; )
    r = "0" + r;
  return n + r;
}
function i(e, a) {
  var n = a || "", r = e > 0 ? "-" : "+", t = Math.abs(e), o = s(Math.floor(t / 60), 2), u = s(Math.floor(t % 60), 2);
  return r + o + n + u;
}
function l(e, a) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + s(Math.abs(e) / 60, 2);
  }
  return i(e, a);
}
function O(e, a) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), t = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(t);
  var u = a || "";
  return n + String(t) + u + s(o, 2);
}
const g = v;
export {
  g as default
};
